import { storeAction } from "../storeActions.constant";
import { storeGetters } from "../storeGetters.constant";
import { storeMutation } from "../storeMutations.constant";
import { wrapAction } from "../../common/utils/actionLifecycle";
import axios from "axios";
import { getBasicHeaders } from "@/common/utils/utils";
import {
    getAlphabeticallyFilteredResources,
    getMappedResourcesByCategories,
} from "../../components/YpoResources/ypoResources.constant";
import orderBy from "lodash/orderBy";

const ypoResourcesState = {
    baseURL: process.env.VUE_APP_BASE_URL,
    resourcesFromApi: null,
    ypoResources: {
        adImage: null,
        buttonList: null,
        resourcesByCategory: null,
        resourcesByAlphabeticalOrder: null,
        canEditResourceLinks: false, 
    },
    ypoResourcesMobile: {
        resourcesByCategoryMobile: null,
        resourcesByAlphabeticalOrderMobile: null,
    },
    hideCategoriesWithExtensiveLinks: true,
    
};

const ypoResourcesMutations = {
    [storeMutation.setYpoResources]: (state, data) => {
        state.resourcesFromApi = { ...data };
        state.ypoResources.adImage = data.advertisementTiles && data.advertisementTiles.length
            ? data.advertisementTiles.find(tile => tile.type && tile.type.toLowerCase() === "image")
            : null;
        state.ypoResources.buttonList = data.advertisementTiles && data.advertisementTiles.length
            ? data.advertisementTiles.filter(tile => tile.type && tile.type.toLowerCase() === "button")
            : null;
        if (state.ypoResources.buttonList && state.ypoResources.buttonList.length) {
            state.ypoResources.buttonList = orderBy(state.ypoResources.buttonList, "displayOrder", "asc");
        }
        state.ypoResources.canEditResourceLinks = data.canEditResourceLinks;
        state.ypoResources = {
            ...state.ypoResources,
            resourcesByCategory: getMappedResourcesByCategories(data, data.canEditResourceLinks),
            resourcesByAlphabeticalOrder: getAlphabeticallyFilteredResources(data.resourceLinks),
        };        
    },
    [storeMutation.handleShowMoreForCategory]: (state) => {
        state.hideCategoriesWithExtensiveLinks = false;
    },
};

const ypoResourcesActions = {
    [storeAction.getYpoResources]: wrapAction(storeAction.getYpoResources, ({ state, commit }) => {
        return axios({
            url: `${state.baseURL}profiles/api/tools/get-resource-categories-and-links`,
            //url: '/mocks/ypoResources.json',
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setYpoResources, Object.create(response.data));
                return response.data;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.saveYpoResourcesCategories]: wrapAction(storeAction.saveYpoResourcesCategories, ({ state, commit }, requestBody) => {
        const requestData = requestBody && requestBody.id ? requestBody : {
            categoryName: requestBody.categoryName,
            isActive: true,
        };
        return axios({
            url: `${state.baseURL}profiles/api/tools/save-category`,
            headers: getBasicHeaders(),
            data: requestData,
            method: 'POST',
        })
            .then((response) => {
                commit(storeMutation.setYpoResources, Object.create(response.data));
                return response.data;
            })
            .catch((err) => {
                console.log(err);
                throw err.response.data;
            });
    }),
    [storeAction.saveYpoResourcesLinks]: wrapAction(storeAction.saveYpoResourcesLinks, ({ state, commit }, requestBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/tools/save-Resource-links`,
            headers: getBasicHeaders(),
            data: requestBody,
            method: 'POST',
        })
            .then((response) => {
                commit(storeMutation.setYpoResources, Object.create(response.data));
                return response.data;
            })
            .catch((err) => {
                console.log(err);
                throw err.response.data;
            });
    }),
    [storeAction.saveYpoResourcesButtons]: wrapAction(storeAction.saveYpoResourcesButtons, ({ state, commit }, requestBody) => {
        return axios({
            url: `${state.baseURL}profiles/api/tools/save-advertisement-links`,
            headers: getBasicHeaders(),
            data: requestBody,
            method: 'POST',
        })
            .then((response) => {
                commit(storeMutation.setYpoResources, Object.create(response.data));
                return response.data;
            })
            .catch((err) => {
                console.log(err);
                throw err.response.data;
            });
    }),
};
const ypoResourcesGetters = {
    [storeGetters.ypoResources]: state => state.ypoResources,
    [storeGetters.hideCategoriesWithExtensiveLinks]: state => state.hideCategoriesWithExtensiveLinks,
};

export default {
    namespaced: true,
    state: {
        initialState: ypoResourcesState,
        ...ypoResourcesState,
    },
    mutations: { ...ypoResourcesMutations },
    actions: { ...ypoResourcesActions },
    getters: { ...ypoResourcesGetters },
};
